class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element) return;

      // Use section.section if available, otherwise fallback to section.id
      const sectionKey = section.section || section.id;
      const sectionHTML = parsedState.sections[sectionKey];
      if (!sectionHTML) return;

      if (section.selector) {
        element.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      } else {
        // For cart-icon-bubble, the HTML comes wrapped in .shopify-section
        // We need to extract the inner content
        const parsedHTML = new DOMParser().parseFromString(sectionHTML, 'text/html');
        const sectionContent = parsedHTML.querySelector('.shopify-section');
        if (sectionContent) {
          element.innerHTML = sectionContent.innerHTML;
        } else {
          // Fallback: if .shopify-section is not found, try to use the HTML directly
          // This handles cases where the section HTML structure might be different
          const bodyContent = parsedHTML.body;
          if (bodyContent && bodyContent.innerHTML) {
            element.innerHTML = bodyContent.innerHTML;
          }
        }
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
